/**
 *
 * Styles for TextAndIcon
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";

export const TextAndIconWrapper = styled.span`
  display: ${(props) => (props.inlined ? "inline-flex" : "flex")};
  align-items: center;
  cursor: pointer;
  position: relative;
  ${(props) => `margin-left: ${props.leftMargin};`}
  ${(props) => `margin-bottom: ${props.bottomMargin};`}
  ${(props) => (props.alignRight ? "justify-content: flex-end;" : "")}

  .icon {
    min-width: ${(props) => (props.hasTooltip ? "40px" : "auto")};
    justify-content: center;
  }
`;

export const SpanStyled = styled(DhlText)`
  & > *:is(p, span) {
    padding-right: var(--dui-size-space-5x);
    padding-top: var(--dui-size-space-1x);
    line-height: 25px;
    position: relative;
  }
`;
